import { HomepageComponent } from '@app/homepage/homepage/homepage.component';
import { Routes } from "@angular/router";

export const homepageModuleRoutes: Routes = [
  {
    path: '',
    component: HomepageComponent,
    pathMatch: 'full',
    data: { bodyCssClass: 'bjootify-homepage' }
  }
];
